import http from "../plugins/Axios";
// import { makerPagination } from "@/utils/pureFunctions";

export default {
  actions: {
    async getTnVdProduct(_, query) {
      try {
        const params = query || {};
        const {
          data: { data, total },
        } = await http.get("/office-product/list", {
          params,
        });
        return {
          data: data.map((item, index) => {
            item.index = index + 1;
            return item;
          }),
          total,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async getOzlProductList(_, query) {
      try {
        const params = query || {};
        const {
          data: { data, total },
        } = await http.get("/contract/office/list", {
          params,
        });
        return {
          data: data.map((item, index) => {
            item.index = index + 1;
            return item;
          }),
          total,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
